import { MarkdownContent } from 'elements/visual/MarkdownContent';
import { motion } from 'framer-motion';
import { EVariables } from 'libs/styles/styling';
import { useContext, useState } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    text: string;
    className?: string;
}

export const EventDescription = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const [showDescription, setShowDescription] = useState(false);
    const isWide = ctxEventView?.isWide;

    const variants = {
        shown: { maxHeight: '2000px' },
        closed: { maxHeight: '500px' }
    };

    const fullDescription = props.text;
    const partialDescriptionLimit = isWide ? 350 : 100;
    const partialDescription = props.text?.substring(0, partialDescriptionLimit);

    const isPartialVisible = props.text?.length > partialDescriptionLimit && !showDescription;

    return (
        <S_EventDescription
            className={props.className}
            animate={showDescription ? 'shown' : 'closed'}
            variants={variants}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            initial={'closed'}
            onClick={() => {
                setShowDescription(!showDescription);
            }}
            $isWide={isWide}
        >
            <S_Description
                isWide={isWide}
                $isWide={isWide}
                text={isPartialVisible ? partialDescription : fullDescription}
                showReadMore={isPartialVisible}
            />
        </S_EventDescription>
    );
};

const S_EventDescription = styled(motion.div)<{ $isWide: boolean }>`
    width: 100%;
    background-color: #fafcfe;
    padding: 15px 20px;
    border-radius: ${EVariables.Radius1};
    overflow: hidden;
    ${(props) => {
        if (props.$isWide) {
            return css`
                background-color: #eaf0f5;
                padding: 30px 40px;
                border-radius: ${EVariables.Radius2};
            `;
        }
    }}
`;

const S_Description = styled(MarkdownContent)<{ $isWide: boolean }>`
    font-size: 14px;
    ${(props) => {
        if (props.$isWide) {
            return css`
                font-size: 16px;
                line-height: 31px;
            `;
        }
    }}
`;
